import { type FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useURLSearchParam } from "widgets/hooks";

import type { Configuration } from "@/graphql.ts";
import { redirectTo } from "@/redux/modules/auth.ts";
import type { IAppState } from "@/redux/reducer.ts";
import type { ReduxDispatch } from "@/redux/redux-utils.ts";
import { LoginPage, LoginPageExtern } from "@/ui-modules/core/LoginPage.tsx";

export const AuthLoginPage: FC = () => {
  const dispatch = useDispatch<ReduxDispatch>();
  const configuration = useSelector<IAppState, Configuration>((state) => state.config.configuration);
  const isAuthenticated = useSelector<IAppState, boolean>((state) => {
    return state.auth.isAuthenticated && !state.auth.isAuthenticating;
  });
  const redirect = useURLSearchParam("redirect");

  useEffect(() => {
    if (isAuthenticated) {
      // If you are already logged in, it doesn't make sense to show you the login page. So we redirect.
      // Even if you redirect to login, as we don't pass the redirect search param, it will end up at /home
      dispatch(redirectTo(redirect ? decodeURIComponent(redirect) : "/home"));
    }
    // We don't react to the change of isAuthenticated because the redirection will be done on the LoginPage
    // This is used only on the case of loading the login page while already logged.
  }, []);

  if (isAuthenticated) {
    return null;
  } else if (configuration?.application?.externalAuthentication) {
    return <LoginPageExtern />;
  } else {
    return <LoginPage />;
  }
};
